function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.429 2.256c0-.693.537-1.256 1.2-1.256H9.37c.663 0 1.2.563 1.2 1.256v1.616h2.914c.285 0 .515.24.515.538 0 .298-.23.539-.514.539h-.207l-.56 8.217C12.647 14.2 11.826 15 10.836 15H5.163c-.99 0-1.81-.8-1.881-1.834l-.56-8.217h-.208A.527.527 0 012 4.41c0-.297.23-.538.514-.538H5.43V2.256zM3.752 4.95l.556 8.14c.032.47.405.834.855.834h5.674c.45 0 .823-.364.855-.833l.556-8.141H3.752zm5.79-1.077H6.458V2.256c0-.099.077-.18.172-.18H9.37c.095 0 .172.081.172.18v1.616zM6.63 6.744c.284 0 .514.24.514.538v4.308c0 .297-.23.538-.514.538a.527.527 0 01-.515-.538V7.282c0-.297.23-.538.515-.538zm2.742 0c.284 0 .515.24.515.538v4.308c0 .297-.23.538-.515.538a.527.527 0 01-.514-.538V7.282c0-.297.23-.538.514-.538z",
  fill: "#2D2D2D"
});
function SvgTacho(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Tacho.svg";
export { SvgTacho as ReactComponent };